import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { BaseButtonComponent } from '@shared/ui/buttons/base-button/base-button.component';

@Component({
  selector: 'crm-button-delete',
  standalone: true,
  imports: [BaseButtonComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <crm-base-button
      variant="delete"
      [isLoading]="isLoading"
      [disabled]="disabled"
      [type]="type"
      [wide]="wide"
      [width]="width"
      [suffixIcon]="suffixIcon"
      (clicked)="clicked.emit($event)"
      ><ng-content></ng-content
    ></crm-base-button>
  `,
})
export class ButtonDeleteComponent {
  @Input() disabled = false;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() isLoading = false;
  @Input() suffixIcon?: string = '';
  @Input() wide?: boolean = false;
  @Input() width?: number;
  @Output() clicked = new EventEmitter<MouseEvent>();
}
